export class UTMSource {
    constructor(
        public source: string,
        public colour: string
    ) { }
}

export class DiaryPreferences {

    constructor(
        public confirmAddBooking: boolean,
        public merchantBookingsRequireChargeByDefault: boolean,
        public merchantRequiresCancellationReason: boolean | null,
        public pendingPaymentExpiryMinutes: number | null,
        public utmSources: UTMSource[],
        public switchToSMS: boolean,
        public requireUserPinCode: boolean,
        public hideClosedBookingSlots: boolean,
        public customerFirstNameRequired = false,
        public customerLastNameRequired = false,
        public customerEmailAddressRequired = false,
        public customerPhoneNumberRequired = false,
    ) { }

    pendingPaymentExpiryDateBookedAtDate(
        bookedAtDate: Date,
        overriddenPendingPaymentExpiryMinutes?: number | null
    ): Date | null {
        const expiryMinutes = overriddenPendingPaymentExpiryMinutes !== undefined
            ? overriddenPendingPaymentExpiryMinutes : this.pendingPaymentExpiryMinutes
        if (expiryMinutes === null) {
            return null
        }
        const expiryDate = new Date(bookedAtDate)
        const expiryMilliseconds = expiryMinutes * 60 * 1000
        expiryDate.setTime(expiryDate.getTime() + expiryMilliseconds)
        return expiryDate
    }
}
